// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module__link___30jGW","relatedApp":"styles-module__relatedApp___P6abt","description":"styles-module__description___1_qjm"};